import React from 'react';
import OrdenCompra from 'components/Tvendo/Shopping/Operations/OrdenCompra/OrdenCompra';

export default function () {
  return <OrdenCompra />;
}
